import { FC } from 'react'
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import AuthBanner from '../../components/authentication/AuthBanner';


const LayoutAuth: FC = ({ children }) => {
  const site_key = process.env['REACT_APP_RECAPTCHA_SITE_KEY']
  const year = new Date().getFullYear()
  return (
    <>
      <Helmet>
        <title>Register | OnData</title>
        <script src={`https://www.recaptcha.net/recaptcha/api.js?render=${site_key}`}></script>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          position: 'relative'
        }}
      >
        <AuthBanner />
        <Container
          maxWidth="sm"
          sx={{ py: 10 }}
        >
          {children}
        </Container>
        <Typography
          aria-hidden="true"
          color='textSecondary'
          variant='body2'
          sx={{ 
            position: 'absolute', 
            bottom: '0.4em',
            left: 'calc(50% - 12em)',
          }}
        >
          Copyright &copy; 2021{year > 2021 && `-${year}`} OnData, Inc. All rights reserved.
        </Typography>
      </Box>
    </>
  );
}

export default LayoutAuth
